import styled from "@emotion/styled";
import theme from "theme";

const FolderStructureContainer = styled.div`
  padding: 10px;
  margin: 5px 15px 10px 10px;
  border-radius: 5px;
  height: 70vh;
  background-color: #f7f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
`;

const SC = {
  FolderStructureContainer,
};

export default SC;
